import { render, staticRenderFns } from "./singleTermMarkentryRow.vue?vue&type=template&id=6e79e5ed&"
import script from "./singleTermMarkentryRow.vue?vue&type=script&lang=js&"
export * from "./singleTermMarkentryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports